import { getIn } from "formik";

const Input = ({ field, form, ...props }) => {
  const newProps = {
    ...props,
    className: `${props.className} ${
      getIn(form.errors, field.name) ? "is-invalid" : ""
    }`,
  };
  return <input {...field} {...newProps} />;
};

export default Input;
